import { Input } from '@/components/Input';
import { useState } from 'react';
import { Icon } from '@/components/Icon';

export function SimplePasswordField({
  value,
  label,
  onChange,
  disabled = false,
  id = 'simple_password',
}: {
  value: string;
  label: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  id?: string;
}) {
  const [visible, setVisible] = useState(false);

  return (
    <Input
      autoComplete="new-password"
      label={label}
      type={visible ? 'text' : 'password'}
      id={id}
      value={value}
      required
      minLength={6}
      maxLength={128}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      append={
        <Icon
          onClick={() => setVisible((value) => !value)}
          icon={visible ? 'eye' : 'eye_closed'}
        />
      }
    />
  );
}
